import { isProd } from '@grantstreet/psc-environment'

// note this is not used due to a race condition bug causing the e-wallet-vue GA setup to override this.
// Also note there isn't a nonprod GA app set up yet.
export const getPayHubGaId = () => isProd()
  ? 'G-2Y53RWJGP0' // PSC > PEx PayHub Prod - GA4
  : 'G-2Y53RWJGP0' // PSC > PEx PayHub Prod - GA4
